import startCase from 'lodash-es/startCase'
import React from 'react'

import { Dropdown, Icon, Radio, Tag, ToolbarButton } from '@fourthwall/components'
import { DotsHorizontalIcon, PayPalIcon } from '@fourthwall/icons'

import type { PaymentMethodItem } from '../../PaymentMethods.types'
import { CreditCardIcon } from '../CreditCardIcon/CreditCardIcon'
import * as S from './PaymentMethodsList.styled'

export type PaymentMethodListProps = {
  selectable?: boolean
  paymentMethods: PaymentMethodItem[]
}

export const PaymentMethodsList = ({
  selectable = false,
  paymentMethods,
}: PaymentMethodListProps) => {
  return (
    <S.Container>
      {paymentMethods.map((paymentMethod) => {
        const { id, selected, invalid, tagsProps, dropdownItemsProps, onClick } = paymentMethod

        const renderTitle = () => {
          if (paymentMethod.type === 'CARD') {
            return (
              <>
                <S.Title>
                  {startCase(paymentMethod.brand)} ending in {paymentMethod.number}
                </S.Title>
                <S.Subtitle>Expires {paymentMethod.expires}</S.Subtitle>
              </>
            )
          }

          // PAYPAL
          return <S.Title withEllipsis>{paymentMethod.email}</S.Title>
        }

        return (
          <S.PaymentMethodContainer
            key={id}
            selected={!!selected}
            selectable={selectable}
            invalid={!!invalid}
            onClick={!invalid ? onClick : undefined}
          >
            {selectable && (
              <S.RadioContainer>
                <Radio checked={!!selected} disabled={!!invalid} />
              </S.RadioContainer>
            )}

            <S.IconContainer>
              {paymentMethod.type === 'CARD' && <CreditCardIcon brand={paymentMethod.brand} />}
              {paymentMethod.type === 'PAYPAL' && <Icon component={PayPalIcon} height={32} />}
            </S.IconContainer>

            <S.TitleContainer>{renderTitle()}</S.TitleContainer>

            {!!tagsProps?.length && (
              <S.TagsContainer>
                {tagsProps.map((tagProps, index) => (
                  <S.TagWrapper key={index}>
                    <Tag {...tagProps} />
                  </S.TagWrapper>
                ))}
              </S.TagsContainer>
            )}

            {!!dropdownItemsProps?.length && (
              <S.DropdownWrapper>
                <Dropdown
                  content={dropdownItemsProps.map((dropdownItemProps, index) => (
                    <Dropdown.Item key={index} {...dropdownItemProps} />
                  ))}
                  position="bottom-end"
                >
                  <ToolbarButton icon={DotsHorizontalIcon} />
                </Dropdown>
              </S.DropdownWrapper>
            )}
          </S.PaymentMethodContainer>
        )
      })}
    </S.Container>
  )
}
